import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function DestinationTypeRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {path: '/destination', component: Index, isProtected: true, permissions: ['destination_index']},
    {path: '/destination/create', component: Create, isProtected: true, permissions: ['destination_create']},
    {path: '/destination/edit/:id', component: Edit, isProtected: true, permissions: ['destination_edit']},

  ];

  return routes;
}
